import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Content } from '../components/content';
import { IContentForm } from '../components/forms/icontent-form';
import { IAuthContextProps, IFetcher } from '../components/with-auth-context';

export interface IRouteMatch {
    id: string;
}

export const withEditorPage = <T, P extends IContentForm<T>>(Component: React.ComponentType<P>, loadItem: (fetcher: IFetcher, id: string | number) => Promise<T>) =>
    class EditorPage extends React.Component<P & RouteComponentProps<IRouteMatch> & IAuthContextProps, { item: T|null }> {
        constructor(props: P & RouteComponentProps<IRouteMatch> & IAuthContextProps){
            super(props);
            this.state={ item: null };
        }
        private onSaveCompleted = () => {
            this.props.history.goBack();
        }
        async componentDidMount() {
            this.setState({
                item: await this.props.callApi((fetcher) => loadItem(fetcher, this.props.match.params.id)) 
            });
        }
        render(): JSX.Element {
            if (!this.state.item) return <LinearProgress />;

            return <Content><Component {...this.props} item={this.state.item} onSaveCompleted={this.onSaveCompleted} isEditing={true} /></Content>
        }
    };


// WEBPACK FOOTER //
// ./src/pages/editor-page.tsx